// App.js
import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider, Helmet } from '@dr.pogodin/react-helmet';
import { useState } from 'react';

import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import HomeBanner from './Components/HomeBanner/HomeBanner';
import HomeAboutUs from './Components/HomeAboutUs/HomeAboutUs';
import WhyConnect from './Components/WhyConnect/WhyConnect';
import GetInTouch from './Components/GetInTouch/GetInTouch';
import Services from './Components/ServicesSection/Services/Services';
import AboutUs from './Components/AboutUs/AboutUs';
import ContactUs from './Components/ContactUs/ContactUs';
import PaymentStrategy from './Components/ServicesSection/PaymentStrategy/PaymentStrategy';
import TechClouds from './Components/ServicesSection/TechClouds/TechClouds';
import BussinessConsultency from './Components/ServicesSection/BussinessConsultency/BussinessConsultency';
import Marketing from './Components/ServicesSection/Marketing/Marketing';
import SuccessStory from './Components/SuccessStory/SuccessStory';
import ScrollToTop from './ScrollToTop';
import FloatingWhatsApp from './Components/Whatsapp/Whatsapp';
import ContactFormModal from './Components/ContactFormModal/ContactFormModal';
import Thankyou from './Components/Thankyou/Thankyou';
import PageNotFound from './Components/PageNotFound/PageNotFound';
import TermsAndCondition from './Components/Policy/TermsAndCondition';
import PrivacyPolicy from './Components/Policy/PrivacyPolicy';
import RefundPolicy from './Components/Policy/RefundPolicy';

const CanonicalTag = () => {
  const location = useLocation();
  const currentUrl = `${window.location.origin}${location.pathname}`;
  return (
    <Helmet>
      <link rel="canonical" href={currentUrl} />
    </Helmet>
  );
};

function App() {
  const [openForm, setOpenForm] = useState(false);
  const openContactForm = () => setOpenForm(true);

  return (
  
    <HelmetProvider>
      <Router>

        <CanonicalTag />

        <ScrollToTop />
        <Header openContactForm={openContactForm} />

        <Routes>
          <Route
            path="/"
            element={
              <>
                <Helmet>
                  <title>Home | PayTech Advisor</title>
                  <meta name="description" content="Your PayTech Advisor home" />
                </Helmet>

                <HomeBanner openContactForm={openContactForm} />
                <Services  openContactForm={openContactForm}/>
                <HomeAboutUs />
                <WhyConnect />
                <GetInTouch openContactForm={openContactForm} />
                <SuccessStory />
                 
              </>
            }
          />

          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs openContactForm={openContactForm} />} />
          <Route path="/payment-strategy-and-advisory" element={<PaymentStrategy openContactForm={openContactForm} />} />
          <Route path="/tech-and-cloud-solution" element={<TechClouds openContactForm={openContactForm} />} />
          <Route path="/Thankyou" element={<Thankyou />} />
          <Route path="/business-consultancy" element={<BussinessConsultency openContactForm={openContactForm} />} />
          <Route path="/marketing" element={<Marketing openContactForm={openContactForm} />} />
     <Route path="/terms-and-condition" element={<TermsAndCondition />} />

          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
               <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>

        <Footer openContactForm={openContactForm} />
        <FloatingWhatsApp />
        <ContactFormModal open={openForm} onClose={() => setOpenForm(false)} />
      </Router>
    </HelmetProvider>
  );
}

export default App;
